/*========================================================================
* $Id: editor.js 72847 2013-05-23 15:52:33Z jakob.praher $
*
* Copyright © Mindbreeze Software GmbH, Linz, Austria, 2005-2013
*
* Der Nutzer des Computerprogramms anerkennt, dass der oben stehende
* Copyright-Vermerk im Sinn des Welturheberrechtsabkommens an der vom
* Urheber festgelegten Stelle in der Funktion des Computerprogramms
* angebracht bleibt, um den Vorbehalt des Urheberrechtes genuegend zum
* Ausdruck zu bringen. Dieser Urheberrechtsvermerk darf weder vom Kunden,
* Nutzer und/oder von Dritten entfernt, veraendert oder disloziert werden.
* =========================================================================*/

define([
    "i18n/i18n",
    "backbone",
    "jquery",
    "underscore",
    "utils/string",
    "libs/jquery.htmlClean-1.3.0.min",
    "libs/faba5.editor-1.1",
    "bootstrap"
  ],
function(i18n, Backbone, $, _, StringUtils) {

  var CHANGE_TIMEOUT = 500;

  var ValueEditors = {};
  // TODO: make extensible
  //       use factory like Formats
  //

  var ValueEditor = Backbone.View.extend({
    events: {
      "change": "_onChange",
      "blur": "_changeAfterTimeout"
    },

    initialize: function(options) {
      var that = this;
      this.changed = false;
      if (options.value !=  null) {
        this.setValue(options.value);
        this.el.defaultValue = options.value;
      }

      this.el.id = this.options.name;
    },
    
    value: function() {
      return this._value;
    },

    defaultValue: function() {
      return this.el.defaultValue;
    },

    setValue: function(value) {
      if (this._value != value) {
        this._value = value;
        if (this.getUiValue() !== this._value) {
          this.updateUiValue();
        }
        this.changed = true;
        this.trigger("change", this, value);
      }
    },

    updateUiValue: function () {
      this.el.value = this._value;
    },

    _onChange: function() {
      this.setValue(this.getUiValue());
    },

    _changeAfterTimeout: function () {
      var that = this;

      if (this._changeTimeout) {
        window.clearTimeout(this._changeTimeout);
      }
      this._changeTimeout = window.setTimeout(function () {
          that._onChange();
      }, CHANGE_TIMEOUT);
    },

    getUiValue: function () {
      return this.el.value;
    },

    update: function() {
      var ret = this.options.update(this.value());
      this.changed = false;
      this.el.defaultValue = this.value();
      return ret;
    },

    render: function () {
      return this;
    }
  });

  var TextInputEditor = ValueEditor.extend({
    tagName: 'input',

    render: function() {
      this.el.setAttribute("type", "text");
      return this;
    }
  });

  var CheckboxEditor = ValueEditor.extend({
    tagName: 'input',
    position: 'before',
    additionalClassNames: 'checkbox',

    render: function() {
      this.el.setAttribute("type", "checkbox");
      this.updateUiValue();
      return this;
    },
    
    updateUiValue: function () {
      this.el.checked = this._value;
    },

    getUiValue: function () {
      return this.el.checked;
    },
  });

  var TextSelectEditor = ValueEditor.extend({
    tagName: 'select',

    initialize: function(options) {
      ValueEditor.prototype.initialize.apply(this, arguments);

      var that = this;
      this.changed = false;
      
      if (options.values) {
        if (options.values.bind && options.model) {
          var selectOptions = options.model.get(options.values.bind.options);
          var textKey  = options.values.bind.text|| options.values.bind.value || "text";
          var valueKey = options.values.bind.value || "value";
          
          if (selectOptions) {
            _.each(selectOptions, function(option) {
              if (options.defaultValue == option[valueKey]) {
                that.el.appendChild(that.make("option", {value: option[valueKey], selected: true}, option[textKey]));
              }
              else {
                that.el.appendChild(that.make("option", {value: option[valueKey]}, option[textKey])); 
              }
            });
          }
        } else {
          _.forEach(options.values, function (value, key) {
            if (!value) return;

            var theValue = value.value === undefined ? value : value.value,
                attrs = {
                  value: theValue
                };

            if (options.defaultValue == theValue) {
              attrs["selected"] = true;
            }
            that.el.appendChild(that.make("option", attrs, value.text === undefined ? value : value.text));
          });
        }
      }
      
      if (options.value) {
        this.setValue(options.defaultValue);
        this.el.defaultValue = options.defaultValue;
      }
    }

  });

  var TextAreaEditor = ValueEditor.extend({
    tagName: 'textarea',
    additionalClassNames: 'full-width',
   
  });


  var JsonEditor = ValueEditor.extend({
    tagName: 'div',
    additionalClassNames: 'constraint-container',
    events: {
      'blur .json-textarea': 'handleTextChange',
    },

    initialize: function() {
      this.el.value = this.options.values;
      this.options.values = this.options.value || [];
      this.isCancelClick = false;
      this.options.defaultValue = "";

      if (this.options.value) {
        this.setInputValue(this.options.value, this.options.name);
      } else {
        this.options.value = "";
        this.setInputValue(this.options.value, this.options.name);
      }

    },

    setInputValue: function(value, name) {
      var isJSON = this.isValueJSON(value);
      if(value) {
        if(isJSON) {
          var strValue = JSON.stringify(JSON.parse(value));
          value =  StringUtils.whitespaceToNbsp(strValue);
        } else {
          var strValue = StringUtils.whitespaceLineBreaksToNbsp(value);
          strValue = StringUtils.largerSignToHtmlEntity(strValue);
          value = StringUtils.multipleNbspToOneWhitespace(strValue);
        }
      }

      this.el.innerHTML = '\
        <div class="json-input-container">\
          <textarea class="json-textarea">'+ this.options.value +'</textarea>\
          ' + this.getValidationError(isJSON, value) + '\
        </div>\
      ';
    },

    handleTextChange: function() {
      var newVal = $('.json-textarea').val();

      if (newVal !== '') {
        this.options.value = newVal;
      } else {
        this.options.value = this.options.defaultValue;
      }

      this.setInputValue(this.options.value, this.options.name);
      this.setValue(this.options.value);
    },

    getValidationError: function(isJSON, value) {
      if (isJSON || !value) {
        return '';
      }

      return '<span class="error-msg">'+ i18n('please_provide_a_valid_json_value') +'</span>';
    },

    isValueJSON: function(value) {
      try {
        if(JSON.parse(value) && !!value) {
          return true;
        }
      } catch (e) {
        return false;
      }
    }
  });

  var QueryExprEditor = ValueEditor.extend({
    tagName: 'div',
    additionalClassNames: 'constraint-container',
    events: {
      'click .query-input-container .edit-query': 'editQueryExp',
      'mousedown .query-input-container .cancel-query': 'cancelQueryExp',
      'mousedown .query-input-container .update-query': 'newSubQueryValue',
      'blur .query-textarea': 'newSubQueryValue',
    },

    initialize: function() {
      this.el.value = this.options.values;
      this.options.values = this.options.value || [];
      this.isCancelClick = false;
      this.options.defaultValue = "ALL";

      if (this.options.value) {
        this.setInputValue(this.options.value, this.options.name);
      } else {
        this.options.value = "ALL";
        this.setInputValue(this.options.value, this.options.name);
      }
      this.boundBlurHandler = this.newSubQueryValue.bind(this);
    },

    setInputValue: function(value, name) {
      var isJSON = this.isValueJSON(value);
      if(value) {
        if(isJSON) {
          var strValue = JSON.stringify(JSON.parse(value));    
          value =  StringUtils.whitespaceToNbsp(strValue);
        } else {
          var strValue = StringUtils.whitespaceLineBreaksToNbsp(value);
          strValue = StringUtils.largerSignToHtmlEntity(strValue);
          value = StringUtils.multipleNbspToOneWhitespace(strValue);
        }
      }
      
      this.el.innerHTML = '\
        <div class="query-input-container">\
          <input value=' + value + ' id='+ name +' type="text" readonly>\
          <div class="query-btn-container">\
          ' + this.makeButton(i18n("section_button_edit"), "pencil", "edit-query") + '\
          </div>\
        </div>\
        ' + this.makeQueryCheckContainer(isJSON) + '\
      '; 
    },

    editQueryExp: function() {
      var textarea = document.createElement('textarea');
      textarea.className = 'query-textarea';
      textarea.value = this.options.value;
  
      var buttonContainer = this.el.querySelector(".query-btn-container");
      buttonContainer.innerHTML = this.makeButton(i18n("editor_update"), "ok-sign", "update-query") +
          ' ' +
          this.makeButton(i18n("Cancel"), "remove-sign", "cancel-query");
  
      this.queryTextArea = textarea;
      this.el.appendChild(textarea);
      this.queryTextArea.addEventListener('blur', this.boundBlurHandler);
    },
    
    newSubQueryValue: function() {
      var newVal = $('.query-textarea').val();

      if (this.isCancelClick) {
        this.isCancelClick = false;
        return;
      };

      if (newVal !== '') {
        this.options.value = newVal;
      } else {
        this.options.value = this.options.defaultValue;
      }

      this.setInputValue(this.options.value, this.options.name);
      this.setValue(this.options.value);
      if (this.queryTextArea) {
        this.queryTextArea.removeEventListener('blur', this.boundBlurHandler);
      } 
    },

    cancelQueryExp: function() {
      this.isCancelClick = true;
      this.setInputValue(this.options.value, this.options.name);
    },

    makeButton: function(value, icon, className) {
      return '<button class="btn btn-white '+ className +'" title="'+ value +'"><i class="icon-'+ icon +'"></i> '+ value +'</button>';
    },

    makeQueryCheckContainer: function(isValueJson) {
      var isChecked = isValueJson ? "checked" : "";
      return '\
        <div class="query-check-container">\
          <span>'+ i18n("editor_text_query") +'</span>\
          <label class="switch query-check-label"><input type="checkbox" class="query-check" ' + isChecked + '><span class="slider round"></span></label>\
          <span>'+ i18n("editor_structural_query") +'</span>\
        </div>\
      '
    },

    isValueJSON: function(value) {
      try {
        if(JSON.parse(value) && !!value) {
          return true;
        }
      } catch (e) {
        return false;
      }
    }

  });

  var KeyValueEditor = ValueEditor.extend({
    tagName: 'div',
    additionalClassNames: 'table-container',
    events: {
      'click .json-key-editor .add-item': 'addModel',
		  'click .json-key-editor .delete-model': 'deleteTableRow',
      'keyup .json-key-editor .edit-item' : '_changeAfterTimeout',
    },

    initialize: function() {
      this.el.value = this.options.values;
      this.options.values = this.options.value || [];

      this.el.innerHTML = '\
      <table class="json-key-editor">\
        <thead>\
          <tr>\
            ' + this.getTdElement("name", "placeholder", "Key") +'\
            ' + this.getTdElement("expr", "placeholder", "Value") + '\
            <td><button class="btn btn-primary add-item">+</button></td>\
          </tr>\
        </thead>\
        <tbody class="json-list"></tbody>\
      </table>\
      ';
      
      this.renderTableRows(this.options.values);
        
    },

    renderTableRows: function(list) {
      var that = this;
      var tBody = $(this.el).find(".json-key-editor .json-list")[0]; 

      tBody.innerHTML = ''; 
      _.each(list, function(item, index) {
        tBody.innerHTML += '\
        <tr data-index= ' + index + '>\
          ' + that.getTdElement("name", "value", item.name, "edit-item") +'\
          ' + that.getTdElement("expr", "value", item.expr, "edit-item") + '\
          <td><button class="btn btn-danger delete-model">x</button></td>\
        </tr>\
        ';
      });

    },

    getTdElement: function(className, attribute, value, eventClass) {
      eventClass = eventClass || '';
      return '\
        <td>\
        <span class="value-editor ' + eventClass + '">\
            <input type="text" class="form-control ' + className + '-input" ' + attribute + '="' + value + '">\
          </span>\
        </td>\
      ';
    },

    addModel: function() {
      var that = this;
      var key = $('.name-input').val();
      var value = $('.expr-input').val();


      if (key && value) {
        that.options.values.push({name: key, expr: value});
        $('.name-input').val('');
        $('.expr-input').val('');
        that.renderTableRows(that.options.values); 
        that.setValue(JSON.stringify(that.options.values));
      }
    },

    onJsonDataChanged: function(tr) {
      var jsonData = this.options.values;
      var key = tr.querySelector('.name-input').value;
      var value = tr.querySelector('.expr-input').value;
      var index = tr.dataset.index;

      this.options.values[index] = {name: key, expr: value};
      
      this.cloneTableList(jsonData);
      this.setValue(JSON.stringify(jsonData));
    },  

    deleteTableRow: function(e) {
      var jsonData = this.options.values;
      var tr =  e.target.parentElement.parentElement;
      var index = tr.dataset.index;

      for( var i = 0; i < jsonData.length; i++){
        if (index == i) {
          jsonData.splice(index, 1);
        }
      };

      tr.remove(e);
      this.cloneTableList(jsonData);
      this.setValue(JSON.stringify(jsonData));
      this.renderTableRows(jsonData);
    },

    _changeAfterTimeout: function(e) {
      var that = this;
      var tr = e.target.parentElement.parentElement.parentElement;
      if (this._changeTimeout) {
        window.clearTimeout(this._changeTimeout);
      }
      this._changeTimeout = setTimeout(function () {
          that.onJsonDataChanged(tr);
      }, CHANGE_TIMEOUT);
    },

    updateUiValue: function () {
      this.el.value = _.clone(this._value);
    },

    
    cloneTableList: function(tableList) {
      this.options.values = _.clone(tableList);
    },

  });

  var ActionEditor = ValueEditor.extend({
    tagName: 'div',
    additionalClassNames: 'action-container',
    events: {
      'click .custom-action': 'handleButtonClick',
    },

    handleButtonClick: function() {
      if (this.options.properties && this.options.properties.actionName) {
        var actionName = this.options.properties.actionName;
        if (this.options.application[actionName] && (typeof this.options.application[actionName] === "function")) {
          this.options.application[actionName](this);
        } else {
          console.error("Application function '" + actionName + "' is not implemented");
        }
      }
    },

    defaultValue: function() {
      if (this.options.application && this.options.application.show360DegreeWizard) {
        return this.el.defaultValue;
      }
      return '';
    },

    initialize: function() {
      var label = '';
      if (this.options.properties && this.options.properties.actionLabel) {
        label = this.options.properties.actionLabel;
      }
      
      this.el.innerHTML = '\
        <button class="btn btn-primary custom-action"> \
          ' + i18n(label) + '\
        </button \
      ';          
    }
  });

  ValueEditors["enum"]      = TextSelectEditor;
  ValueEditors["string"]    = TextInputEditor;
  ValueEditors["QueryExpr"] = QueryExprEditor;
  ValueEditors["int"]       = TextInputEditor;
  ValueEditors["mustache"]  = TextAreaEditor;
  ValueEditors["JsonInput"]  = JsonEditor;
  ValueEditors["text"]  = TextAreaEditor;
  ValueEditors["boolean"]   = CheckboxEditor;
  ValueEditors["keyValue"]  = KeyValueEditor;
  ValueEditors["action"]    = ActionEditor;
  ValueEditors.ValueEditor  = ValueEditor;

  return ValueEditors;
});
